Ext.define('SA.model.Notification', {
    constructor({type, id, date, listed, read, titleText, messageHtml}) {
        this.type = type;
        this.id = id;
        this.date = date;
        this.listed = listed;
        this.read = read;
        this.titleText = titleText;
        this.messageHtml = messageHtml;
    },

    didList() {
        return this.listed;
    },

    didRead() {
        return this.read;
    },

    getDate() {
        return this.date;
    },

    getId() {
        return this.id;
    },

    getMessageHtml() {
        return this.messageHtml;
    },

    getTitleText() {
        return this.titleText;
    },

    isAutoShowNotice() {
        return this.type === 'autoshow-notice-titled';
    },

    isUnlistedNonAutoShowNotice() {
        return !this.didList() && !this.isAutoShowNotice();
    },

    isUnreadAutoShowNotice() {
        return !this.didRead() && this.isAutoShowNotice();
    },

    markListed() {
        this.listed = true;
    },

    markRead() {
        this.read = true;
    }
});